import { Box, Divider } from "@mui/material";

const PageHeader = ({
    left,
    right,
    containerSx,
    cardSx,
    dividerSx,
    showDivider = true,
}) => (
    <Box
        sx={{
            position: "sticky",
            zIndex: 1000,
            display: "flex",
            ...containerSx,
        }}
    >
        <Box
            sx={{
                backgroundColor: "white",
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                py: { xs: 2, xl: 0 },
                px: 2,
                boxSizing: "border-box",
                flex: "0 0 auto",
                minHeight: 72,
                display: "flex",
                alignItems: { xs: "stretch", xl: "center" },
                flexWrap: "wrap",
                columnGap: 2,
                rowGap: 3,
                ...cardSx,
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    minWidth: 0,
                    flex: { xs: "1 1 100%", xl: "1 1 auto" },
                }}
            >
                {left}
            </Box>
            {showDivider && left && right && (
                <Divider
                    orientation="vertical"
                    flexItem
                    sx={{
                        display: { xs: "none", xl: "block" },
                        mx: 1,
                        my: 2,
                        ...dividerSx,
                    }}
                />
            )}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    minWidth: 0,
                    flex: { xs: "1 1 100%", xl: "1 1 auto" },
                }}
            >
                {right}
            </Box>
        </Box>
    </Box>
);

export default PageHeader;
